(function () {
  'use strict';

  const PREORDER_PREFIX = 'preorder-';

  const MESSAGES = {
    preorderAlone:
      'Vorbestellungen und reguläre Produkte müssen immer getrennt bestellt werden, ' +
      'da sie zu unterschiedlichen Zeitpunkten versendet werden und dadurch mehrmals Versandkosten anfallen.',
    differentSeries:
      'Vorbestellungen verschiedener Serien werden separat versendet und ' +
      'müssen daher in getrennten Bestellungen aufgegeben werden. ' +
      'Bitte schließe zuerst deinen aktuellen Einkauf ab.',
    noMixWithRegular:
      'Vorbestellungen und reguläre Produkte müssen immer getrennt bestellt werden, ' +
      'da sie zu unterschiedlichen Zeitpunkten versendet werden und dadurch mehrmals Versandkosten anfallen.',
  };

  function getPreorderTags(tagsString) {
    if (!tagsString) return [];
    return tagsString
      .split(',')
      .map((t) => t.trim())
      .filter((t) => t.startsWith(PREORDER_PREFIX));
  }

  async function fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  async function validateAddToCart(newProductTags) {
    const cart = await fetchCart();
    if (!cart.items || cart.items.length === 0) return { valid: true };

    const newPreorderTags = getPreorderTags(newProductTags);
    const newIsPreorder = newPreorderTags.length > 0;

    const cartPreorderTags = new Set();
    let cartHasRegular = false;

    for (const item of cart.items) {
      const itemTags = (
        item.properties && item.properties['_preorder_tags']
          ? item.properties['_preorder_tags']
          : ''
      ).toLowerCase();

      const itemPreorderTags = getPreorderTags(itemTags);
      if (itemPreorderTags.length > 0) {
        itemPreorderTags.forEach((t) => cartPreorderTags.add(t));
      } else {
        cartHasRegular = true;
      }
    }

    const cartHasPreorder = cartPreorderTags.size > 0;

    if (newIsPreorder) {
      if (cartHasRegular) {
        return { valid: false, message: MESSAGES.noMixWithRegular };
      }
      if (cartHasPreorder) {
        const sameSeries = newPreorderTags.some((t) => cartPreorderTags.has(t));
        if (!sameSeries) {
          return { valid: false, message: MESSAGES.differentSeries };
        }
      }
    }

    if (!newIsPreorder && cartHasPreorder) {
      return { valid: false, message: MESSAGES.preorderAlone };
    }

    return { valid: true };
  }

  function showError(message) {
    const existing = document.getElementById('preorder-cart-error');
    if (existing) existing.remove();

    const el = document.createElement('div');
    el.id = 'preorder-cart-error';
    el.setAttribute('role', 'alert');
    el.style.cssText = `
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      background: #1a1a1a;
      color: #fff;
      padding: 16px 24px;
      border-radius: 8px;
      max-width: 480px;
      width: calc(100% - 48px);
      font-size: 14px;
      line-height: 1.5;
      z-index: 99999;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      text-align: center;
    `;
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 6000);
  }

  function getCurrentProductTags() {
    const el = document.getElementById('preorder-product-tags');
    return el ? el.dataset.tags || '' : '';
  }

  function getForm() {
    return document.querySelector('form.product-single__form');
  }

  function attachButtonListener() {
    const form = getForm();
    if (!form || form.__preorderListenerAttached) return;

    form.__preorderListenerAttached = true;

    async function handleSubmit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const tags = getCurrentProductTags();
      const result = await validateAddToCart(tags);

      if (!result.valid) {
        showError(result.message);
        return;
      }

      // Validierung bestanden → Listener entfernen und neu submitten
      form.__preorderListenerAttached = false;
      form.removeEventListener('submit', handleSubmit, true);
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    form.addEventListener('submit', handleSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachButtonListener);
  } else {
    attachButtonListener();
  }

  document.addEventListener('variant:changed', () => {
    const form = getForm();
    if (form) form.__preorderListenerAttached = false;
    attachButtonListener();
  });

})();